import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';

var Popup = /*#__PURE__*/function (_React$Component) {
  _inherits(Popup, _React$Component);

  var _super = _createSuper(Popup);

  function Popup() {
    var _this;

    _classCallCheck(this, Popup);

    _this = _super.apply(this, arguments);

    _this.getTipDirection = function (placement) {
      var directionMap = {
        'top-start': 'top-left',
        'top-end': 'top-right',
        'bottom-start': 'bottom-left',
        'bottom-end': 'bottom-right',
        'left-start': 'left-top',
        'left-end': 'left-bottom',
        'right-start': 'right-top',
        'right-end': 'right-bottom'
      };
      return directionMap[placement] || placement;
    };

    return _this;
  }

  _createClass(Popup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          effect = _this$props.effect,
          content = _this$props.content,
          popupClassName = _this$props.popupClassName,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          placement = _this$props.placement,
          innerRef = _this$props.innerRef;
      if (content === '' || content === undefined || content === null) return null;
      return /*#__PURE__*/React.createElement("div", {
        ref: innerRef,
        className: "roo-tooltip roo-tooltip-".concat(effect, " roo-tooltip-").concat(this.getTipDirection(placement), " ").concat(popupClassName),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-tooltip-arrow"
      }), /*#__PURE__*/React.createElement("div", {
        className: "roo-tooltip-inner"
      }, content));
    }
  }]);

  return Popup;
}(React.Component);

Popup.propTypes = {
  effect: PropTypes.oneOf(['light', 'dark']),
  content: PropTypes.node,
  placement: PropTypes.oneOf(['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end']),
  popupClassName: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};
Popup.defaultProps = {
  effect: 'dark',
  content: '',
  placement: 'top',
  popupClassName: '',
  onMouseEnter: null,
  onMouseLeave: null
};
export default Popup;